import { configure } from '@creditas/event-track';

const eventTrackService = configure({ bu: 'PA', application: 'affiliates-app' });

export { eventTrackService };
